import { render, staticRenderFns } from "./jfgz-pop.vue?vue&type=template&id=35695458&scoped=true&"
import script from "./jfgz-pop.vue?vue&type=script&lang=js&"
export * from "./jfgz-pop.vue?vue&type=script&lang=js&"
import style0 from "./jfgz-pop.vue?vue&type=style&index=0&id=35695458&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35695458",
  null
  
)

export default component.exports